module.exports = __webpack_public_path__ + "img/4.89bff0ba.png";